export default "/images/2af2dc71a96b51349c33b8385533a6bf.avif";